import { Slide } from 'interfaces/slide';

export const normalizeDismissedCaseOrganizationSlideIds = (slideIds?: string[]) => {
  const seen = new Set<string>();
  return (slideIds || []).flatMap((slideId) => {
    const normalized = slideId.trim();
    if (!normalized || seen.has(normalized)) {
      return [];
    }
    seen.add(normalized);
    return [normalized];
  });
};

export const withoutDismissedSlides = (slides: Slide[] | undefined, dismissedSlideIds: string[]) => {
  const dismissed = new Set(normalizeDismissedCaseOrganizationSlideIds(dismissedSlideIds));
  return (slides || []).filter((slide) => slide.id && !dismissed.has(slide.id));
};

export const hiddenCaseOrganizationSlides = (slides: Slide[] | undefined, dismissedSlideIds: string[]) => {
  const dismissed = new Set(normalizeDismissedCaseOrganizationSlideIds(dismissedSlideIds));
  return (slides || []).filter((slide) => dismissed.has(slide.id));
};

export const caseOrganizationSlideLabel = (slide: Slide) => slide.originalFileName || slide.labInternalId || slide.id;

export const studyHasHeOrIhcSlides = (modalityLabels: string[]) =>
  modalityLabels.some((label) => label === 'H&E' || label === 'IHC');
